import { render, staticRenderFns } from "./OpendataCompanyData.vue?vue&type=template&id=f7ee1cc6&"
import script from "./OpendataCompanyData.vue?vue&type=script&lang=js&"
export * from "./OpendataCompanyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports